import { useState } from 'react';
import { useSelector } from 'react-redux';
import useLocalize from '../../utils/hooks/useLocalize';
import CriteriaCheckbox from './CriteriaCheckbox';
import DotLineMenuIcon from './DotLineMenuIcon';
import PlusRoundedEndsIcon from './PlusRoundedEndsIcon';
import RefineTwoBarsIcon from './RefineTwoBarsIcon';
import RefreshIcon from './RefreshIcon';

// Used for filter option buttons with icon (optional) and text
const FilterOptionButton = ({ icon, text, onClick }) => (
  <div className="filter-option-text" onClick={onClick}>
    {icon}
    {text}
  </div>
);

const ScanCriteriaSection = () => {
  const localize = useLocalize();

  // Selector to get scan data from Redux store
  const selectedScan = useSelector((state) => state.scans.selectedScan || null);
  // Keeps the state for all criteria options - to be handled properly later
  const [selectedCriteria, setSelectedCriteria] = useState({
    AllSecurities: true
  });

  return (
    <div className="scan-criteria-section">
      <div className="scan-criteria-section-inner-left">
        {selectedScan && selectedScan.fields ? (
          <>
            <div className="chip-container">
              {selectedScan.fields?.map((field) => (
                <CriteriaCheckbox
                  key={`${selectedScan.id}--${field.id}`}
                  topText={
                    localize(`desktop.scans.criteria.${field.id}`) || field.id
                  }
                  bottomText={localize('desktop.scans.criteria.all')}
                  isSelected={selectedCriteria[field.id]}
                  onClick={() => {
                    const newValue = !selectedCriteria[field.id];
                    setSelectedCriteria((prev) => ({
                      ...prev,
                      [field.id]: newValue
                    }));
                  }}
                />
              ))}
            </div>
            <div className="chip-menu">
              <FilterOptionButton
                icon={<DotLineMenuIcon />}
                text={localize('desktop.scans.scan.details')}
              />
              <FilterOptionButton
                icon={<PlusRoundedEndsIcon />}
                text={localize('desktop.scans.register.to.my.scans')}
              />
            </div>
          </>
        ) : (
          <div className="scans-construction-message">
            {/* Placeholder when no scan selected TBD */}
            {localize('desktop.scans.criteria.construction')}
          </div>
        )}
      </div>
      <div className="chip-action-area">
        <button className="conditions-settings-button">
          <RefineTwoBarsIcon />
          {localize('desktop.scans.scan.settings')}
        </button>
        <div className="filter-option-menu">
          <FilterOptionButton
            icon={<RefreshIcon />}
            text={localize('desktop.scans.clear.settings')}
          />
          <FilterOptionButton
            icon={null}
            text={localize('desktop.scans.use.previous.settings')}
          />
        </div>
      </div>
    </div>
  );
};

export default ScanCriteriaSection;
